import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'multi-select-usage',
  templateUrl: './multi-select-usage.component.html',
  styleUrls: ['./multi-select-usage.component.sass']
})
export class MultiSelectUsageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
